import { Link } from "react-router-dom";
import { IoLogoGooglePlaystore, IoPhonePortraitOutline } from "react-icons/io5";
import { FaAppStore, FaDesktop } from "react-icons/fa";
import { SiHuawei } from "react-icons/si";
import { BsWindows } from "react-icons/bs";

const mobileAppLinks = [
	{
		name: "Google Play",
		icon: <IoLogoGooglePlaystore size={18} />,
		url: "https://play.google.com/store/apps/details?id=com.akellolibrary",
	},
	{
		name: "App Store",
		icon: <FaAppStore size={18} />,
		url: "https://apps.apple.com/zw/app/akello-library/id6451323375",
	},
	{
		name: "Huawei",
		icon: <SiHuawei size={18} />,
		url: "https://appgallery.huawei.com/app/C108363007",
	},
];

const windowsAppLink = {
	name: "Windows",
	icon: <BsWindows size={18} />,
	url:
		process.env.REACT_APP_WINDOWS_APP_LINK ||
		"https://library.akello.co/akello-windowsx64-installation-file.zip",
};

const AppDownloadLinks = ({ compact = false, className = "" }) => {
	if (compact) {
		return (
			<div className={`bg-blue-50 border border-blue-200 rounded-lg p-4 ${className}`}>
				<div className="flex items-center gap-2 mb-2">
					<IoPhonePortraitOutline size={20} className="text-blue-600" />
					<span className="font-medium text-gray-900">Read on Akello Apps</span>
				</div>
				<p className="text-sm text-gray-600 mb-3">
					Download the Akello Library app to read your books
				</p>
				<Link
					to="/downloads"
					className="inline-flex items-center gap-2 text-sm font-medium text-blue-600 hover:text-blue-700"
				>
					View all download options
				</Link>
			</div>
		);
	}

	return (
		<div className={`bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-lg p-4 ${className}`}>
			<div className="flex items-center gap-2 mb-3">
				<div className="p-2 bg-blue-100 rounded-lg">
					<IoPhonePortraitOutline size={20} className="text-blue-600" />
				</div>
				<div>
					<h4 className="font-semibold text-gray-900">Read Your Books</h4>
					<p className="text-xs text-gray-600">Download Akello Library app to start reading</p>
				</div>
			</div>

			{/* Mobile Apps */}
			<div className="mb-3">
				<p className="text-xs font-medium text-gray-500 uppercase mb-2">Mobile Apps</p>
				<div className="flex flex-wrap gap-2">
					{mobileAppLinks.map((link) => (
						<a
							key={link.name}
							href={link.url}
							target="_blank"
							rel="noreferrer noopener"
							className="flex items-center gap-2 px-3 py-2 bg-white rounded-lg border border-gray-200 hover:border-blue-400 hover:bg-blue-50 transition-all text-sm"
						>
							<span className="text-gray-600">{link.icon}</span>
							<span className="font-medium text-gray-700">{link.name}</span>
						</a>
					))}
				</div>
			</div>

			{/* Desktop App */}
			<div className="mb-3">
				<p className="text-xs font-medium text-gray-500 uppercase mb-2">Desktop App</p>
				<a
					href={windowsAppLink.url}
					target="_blank"
					rel="noreferrer noopener"
					className="inline-flex items-center gap-2 px-3 py-2 bg-white rounded-lg border border-gray-200 hover:border-purple-400 hover:bg-purple-50 transition-all text-sm"
				>
					<span className="text-gray-600">{windowsAppLink.icon}</span>
					<span className="font-medium text-gray-700">{windowsAppLink.name}</span>
				</a>
			</div>

			<Link
				to="/downloads"
				className="inline-flex items-center gap-1 text-sm font-medium text-blue-600 hover:text-blue-700"
			>
				<FaDesktop size={14} />
				View all download options
			</Link>
		</div>
	);
};

export default AppDownloadLinks;
